module.exports = __webpack_public_path__ + "img/logo.a6cc20b8.svg";